import React, { FC } from 'react'
import { CMSStaticSection } from './../../../models'
import { Col, Row } from 'antd'
import './JCMSStaticHowTo.scss'
import { JSection } from '../../../JSection'
import { JCMSIcon } from '../../../JCMSIcon'
import { JHeaderTitle } from '../../../JHeaderTitle'
import {JCMSImage} from "../../../JCMSImage";
export interface JCMSStaticHowToProps extends CMSStaticSection.HowTo { }

export const JCMSStaticHowTo: FC<JCMSStaticHowToProps> = props => {
    if (!props.enabled) return <></>

    return (
        <Row className='jcms-static-how-to-container'>
            <Col span={24}>
                {
                    !!props?.sections?.length && props?.sections.map((section, i: number) => {
                        return (
                            <JSection options={section.options} key={i}>
                                <div key={i} className="jcms-static-how-to-item" >
                                    {
                                        section.type !== 'BANNER' && section.image && (
                                            <JCMSIcon image={section.image} />
                                        )
                                    }
                                    <JHeaderTitle title={section.title} text={section.text} subTitle={section.subTitle} align='center' />
                                    {section.type === 'BANNER' && section.image && <div className={'banner'}>
                                        <JCMSImage image={section.image}/>
                                    </div>}
                                </div>
                            </JSection>
                        )
                    })
                }
            </Col>
        </Row>
    )
}